import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ClientProfile } from '@syfo/types/api.client.types';

/**
 * Check authentication status and fetch user profile
 * Returns user profile if authenticated, null otherwise
 */
export const checkAuthThunk = createAsyncThunk<ClientProfile | null>(
  'auth/checkAuth',
  async () => {
    
    try {
      const response = await fetch('/api/me');
      
      if (response.status === 401) {
        // Not authenticated — expected for unauthenticated visitors
        return null;
      }

      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const data: ClientProfile = await response.json();
          return data;
        } else {
          return null;
        }
      }

      // Unexpected non-401 error
      throw new Error(`Auth check failed: ${response.status}`);
    } catch (error) {
      // Network errors in local development
      console.log('[Auth] Auth check failed:', error instanceof Error ? error.message : error);
      return null;
    }
  }
);
